import React, { useContext, useCallback } from 'react';
import LinkFieldView from '../view/LinkFieldView';
import { FormContext, useField } from '../FormContext';
import useTranslations from '../../../hooks/useTranslations';

const LinkFieldEngine = ({ internalId, value, readOnly, setValue }) => {
  const { showAdminFields } = useContext(FormContext);
  const t = useTranslations();
  const onValueChange = useCallback(
    e => {
      setValue(e.target.value, e);
    },
    [setValue]
  );
  if (showAdminFields) {
    const validator = useCallback(value => {
      value = value || value === 0 ? value : '';
      value += '';

      let error = '';
      if (value && value.indexOf('http') !== 0) {
        error = t('forms.fields.error.invalid_link');
      }

      return error;
    }, []);

    useField(internalId, validator);
  } else {
    useField(internalId, null);
  }

  const viewProps = {
    internalId,
    isAdmin: showAdminFields,
    onValueChange,
    readOnly,
    value
  };

  return <LinkFieldView {...viewProps} />;
};

export default LinkFieldEngine;
